import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getSentAll } from '../../../store/sent/actions';
import { formatPhoneNumberAsYouType } from '../../../helpers/formatterHelper';
import { customBrowserFormat, formatBrowserTimeZone } from '../../../components/common/DateTimeFormatter';
import Warning from '../../../assets/admin/modules/warning.png';
import SmLogo from '../../../assets/admin/modules/sm-logo.png';
import { GetAllLocation } from '../../../api/groupsapi';
function Sent() {
    const dispatch = useDispatch();
    const [locations, setLocations] = useState([]);
    const { sentList } = useSelector(state => state.sentlists);
    const [filter, setFilter] = useState({ sort: 3, searchby: '', locationId: 0, start: 0, length: 100 });
    const totalSentCount = sentList[0]?.totalCount;
    const navigate = useNavigate();
    useEffect(() => {
        GetAllLocation().then((response) => {
            if (response.data.success) setLocations(response.data.data);
        });
    }, []);
    useEffect(() => {
        dispatch(getSentAll(filter)); 
    }, [filter]);
    const handleSelectChange = (e) => {
        const selectedLocationId = parseInt(e.target.value);
        setFilter({ ...filter, locationId: selectedLocationId, start:0 });
    };
    // Helper functions
    function renderStatusAction(statusName) {
        const actionClass = getStatusActionClass(statusName);

        return (
            <div className={`admin-table-action space-nowrap ${actionClass}`}>
                {statusName === "Failed" && <img src={Warning} alt="warning" className="failed-warning" />}
                {statusName}
            </div>
        );
    }

    function getStatusActionClass(statusName) {
        switch (statusName) {
            case "Failed":
                return "failed";
            case "Success":
                return "confirm";
            default:
                return "no-response";
        }
    }

    function renderAppointmentAction(appointmentStatus) {
        const actionClass = getAppointmentActionClass(appointmentStatus);

        return (
            <div className={`admin-table-action space-nowrap ${actionClass}`}>
                {appointmentStatus}
            </div>
        );
    }

    function getAppointmentActionClass(appointmentStatus) {
        switch (appointmentStatus) {
            case "Paused":
                return "Paused";
            case "Rescheduled":
                return "schedule";
            case "Confirmed":
                return "confirm";
            case "No Response":
                return "no-response";
            case "Canceled By Patient":
            case "Canceled":
            case "Canceled By Provider":
            case "Missed":
                return "cancel";
            default:
                return "";
        }
    }

    const generatePageNumbers = () => {
        const totalPages = Math.ceil(totalSentCount / filter.length);
        const currentPage = Math.floor(filter.start / filter.length) + 1;
        const maxMiddlePages = 5; // You can adjust this value based on your preference

        const firstPages = Array.from({ length: Math.min(3, totalPages) }, (_, i) => i + 1);
        const lastPages = Array.from({ length: Math.min(3, totalPages - firstPages.length) }, (_, i) => totalPages - i);

        let middlePages = [];
        if (totalPages > firstPages.length + lastPages.length) {
            const startMiddle = Math.max(firstPages.length + 1, currentPage - Math.floor(maxMiddlePages / 2));
            const endMiddle = Math.min(startMiddle + maxMiddlePages - 1, totalPages - lastPages.length);

            middlePages = Array.from({ length: endMiddle - startMiddle + 1 }, (_, i) => startMiddle + i);
        }

        const allPages = [...firstPages, ...middlePages, ...lastPages].sort((a, b) => a - b); // Sort the pages

        const pageNumbers = allPages.map((pageNumber, index) => {
            const newStart = (pageNumber - 1) * filter.length;
            return (
                <React.Fragment key={pageNumber}>
                    {index > 0 && pageNumber !== allPages[index - 1] + 1 && index < allPages.length - 1 && <span>...</span>}
                    <button
                        onClick={() => setFilter({ ...filter, start: newStart })}
                        className={filter.start === newStart ? 'active' : ''}
                    >
                        {pageNumber}
                    </button>
                </React.Fragment>
            );
        });

        return pageNumbers;
    };
    return (     
        <>
            <div className="admin-page-wrap sent-page-wrap">
                <div className="pageContainer page-container-scroll">
                    <div className="admin-page-content">
                        <div className="admin-container ">
                            <div className="admin-page-title-wrap">
                                <h1 className="admin-page-heading">Sent</h1>
                            </div>

                            <div className="admin-bottom-bar filter-bar">
                                <div className="admin-bottom-bar-left">
                                    <input className="admin-default-search quoteradius"
                                        type="text"
                                        placeholder="Search by Name or Phone Number"
                                        value={filter.searchby}
                                        onChange={(e) => setFilter({ ...filter, searchby: e.target.value, start: 0 })}
                                    />
                                </div> 
                            </div>
                            <div className="pt table-scroll">
                                <table className="admin-table">
                                    <tbody>
                                        <tr>
                                            <th onClick={() => setFilter({ ...filter, sort: filter.sort == 1 ? 2 : 1 })} className={filter.sort == 1 ? 'admin-table-name-cell sortable sorted-dn' : (filter.sort == 2 ? 'admin-table-name-cell sortable sorted-up' : 'admin-table-name-cell sortable')} >Name</th>
                                            <th onClick={() => setFilter({ ...filter, sort: filter.sort == 3 ? 4 : 3 })} className={filter.sort == 3 ? 'admin-table-name-cell sortable sorted-dn' : (filter.sort == 4 ? 'admin-table-name-cell sortable sorted-up' : 'admin-table-name-cell sortable')}>Last Sent</th>
                                            <th onClick={() => setFilter({ ...filter, sort: filter.sort == 5 ? 6 : 5 })} className={filter.sort == 5 ? 'admin-table-name-cell sortable sorted-dn' : (filter.sort == 6 ? 'admin-table-name-cell sortable sorted-up' : 'admin-table-name-cell sortable')}>Appt. Date & Time</th>
                                            <th className="admin-table-name-cell">
                                                <select className="admin-default-select" onChange={handleSelectChange} value={filter?.locationId} >
                                                    <option value="0">All</option>
                                                    {locations.map((option, index) => (
                                                        <option key={index} value={option?.id}>
                                                            {option?.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </th>
                                            <th className="admin-table-name-cell">Last Message</th>
                                            <th className="admin-table-name-cell">&nbsp;</th>
                                        </tr>

                                        {sentList && sentList.map((item, index) => (
                                            <tr key={index} className="pointer" onClick={() => navigate(`/history/${item?.id}`)}>
                                                <td>
                                                    <span className="bold space-nowrap">
                                                        {item?.patients?.map((name, nameIndex) => (
                                                            <React.Fragment key={nameIndex}>
                                                                {name?.firstName + ' ' + name?.lastName}
                                                                {nameIndex < item.patients?.length - 1 && <br />}
                                                            </React.Fragment>
                                                        ))}
                                                    </span>
                                                        <br />
                                                        <span className="space-nowrap">{formatPhoneNumberAsYouType(item.number && item.number) || ''}</span>
                                                  
                                                </td>
                                                <td>
                                                    <div className="space-nowrap">
                                                        <div>{customBrowserFormat(item?.lastMessageLog?.createdDate)}</div>
                                                        <div>@ {formatBrowserTimeZone(item?.lastMessageLog?.createdDate)}</div>
                                                    </div>                                                  
                                                </td>
                                                <td>
                                                    <div className="space-nowrap">
                                                        <div >{customBrowserFormat(item?.lastAppointment?.appointmentDateTime)}</div>
                                                        <div>@ {formatBrowserTimeZone(item?.lastAppointment?.appointmentDateTime)}</div>
                                                    </div>                                                 

                                                </td>
                                                <td>
                                                    {item.lastAppointment?.location?.name} 
                                                </td>
                                                <td>
                                                    <span className="admin-round-swatch-container f-weight500">
                                                        {/* use this if you want show user message<span className="admin-round-swatch-last-message bold">*/}
                                                        {/*    {item.lastMessageLog?.body && (*/}
                                                        {/*        <>*/}
                                                        {/*            {item.patients[0]?.firstName?.charAt(0)}*/}{/* First character */}
                                                        {/*            {item.patients[0]?.lastName?.charAt(0)}*/}{/* Last character */}
                                                        {/*        </>*/}
                                                        {/*    )}*/}
                                                        {/*</span>*/}
                                                        <span className="admin-round-swatch-last-message hfh-smlogo bold">
                                                            <img src={SmLogo} alt="logo" />
                                                        </span>
                                                         {item?.lastMessageLog?.body}

                                                    </span>
                                                </td>
                                                <td className="text-right">
                                                    <div className="sent-message-status">
                                                        {item.lastMessageLog?.messageStatus?.name !== "Success" && renderStatusAction(item.lastMessageLog?.messageStatus?.name)}

                                                        {renderAppointmentAction(item.lastAppointment?.appointmentStatus?.name)}
                                                    </div>
                                                   
                                                </td>
                                                
                                            </tr>
                                        ))}

                                    </tbody>
                                </table>
                            </div> 
                            {totalSentCount > filter.length && (
                                <div className="flex-center pagination-wrapper pr-20">
                                    <button
                                        className="pagination-prev-btn"
                                        onClick={() => setFilter({ ...filter, start: Math.max(0, filter.start - filter.length) })}
                                        disabled={filter.start <= 0}
                                    >
                                        <span className="material-symbols-rounded">arrow_back_ios</span>
                                    </button>
                                    {generatePageNumbers()}
                                    <button
                                        className="pagination-forword-btn"
                                        onClick={() => {
                                            const activePage = Math.floor((filter.start + filter.length) / filter.length);
                                            const nextPageStart = activePage * filter.length;
                                            setFilter({ ...filter, start: nextPageStart });
                                        }}
                                        disabled={filter.start + filter.length >= totalSentCount}
                                    >
                                        <span className="material-symbols-rounded">arrow_forward_ios</span>
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Sent;